import { useNavigate, useParams } from "react-router-dom";
import { useStore } from "../../../store";
import { format, set } from "date-fns";
import { Button, Input, Loading } from "src/components/shared";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import EmailVerification from "src/screens/auth/Register/Steps/EmailVerification";
import ChoosePassions from "src/screens/auth/Register/Steps/ChoosePassions";

const Verification = () => {
  const navigate = useNavigate();
  const { courseStore, userStore } = useStore();

  const [step, setStep] = useState<any>(2);
  const [user, setUser] = useState<any>(
    JSON.parse(localStorage.getItem("registrationUser") || "{}")
  );

  const email = JSON.parse(
    localStorage.getItem("registrationUser") || "{}"
  )?.email;

  return (
    <div className="w-screen h-screen overflow-y-auto relative">
      <img
        src="/images/blur-bg.png"
        className="absolute top-0 left-0 w-full h-full object-cover z-[-1]"
      />

      <div className="flex flex-col gap-5 h-full max-w-[1020px] mx-auto sm:justify-center items-center px-5 sm:px-[60px] lg:px-0 pt-10 sm:pt-0">
        <div
          className="flex flex-col items-center gap-6 w-[350px] sm:min-w-[482px] sm:gap-[30px] bg-white rounded-xl p-6 sm:p-10"
          style={{ boxShadow: "0px 18px 51px -16px #00000008" }}
        >
          {step === 2 && (
            <EmailVerification
              email={email}
              setStep={setStep}
              user={user}
              setUser={setUser}
            />
          )}
          {step === 3 && (
            <ChoosePassions user={user} setUser={setUser} afterPayment />
          )}
        </div>
      </div>
    </div>
  );
};

export default Verification;
